@use '@/styles/tokens' as *;

.header {
  display: flex;
  // Reserve the toolbar's control height so a hub's title-only header and the
  // page's title+toolbar header occupy the same height — the toolbar arriving
  // with the lazy page chunk must not shift the tabs rendered below it.
  min-height: 40px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.title {
  margin: 0;
  font-family: var(--font-family-heading);
  font-size: 28px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}
